<template>
    <div class="row introduction-wrapper">
        <div class="col-12">
            <div class="introduction">
                <slot name="introduction"></slot>
            </div>
        </div>
    </div>
</template>